import ConversationRepository from '../../ports/ConversationRepository';

import { Message } from '../../../domain/entities';

export type paginateUserMessagesUseCase = (
  conversationId: string,
  query: {
    where?: [
      string,
      '<' | '<=' | '==' | '>=' | '>',
      string | number | boolean,
    ][];
    limit: number;
    mode: 'prev' | 'next';
    orderBy?: string;
    sort?: 'desc' | 'asc';
    firstId: string;
    lastId: string;
  },
) => Promise<{
  [key: string]: {
    data: Message[] | undefined;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}>;

export const buildPaginateUserMessages = (dependencies: {
  conversationRepo: ConversationRepository;
}): paginateUserMessagesUseCase => {
  const { conversationRepo } = dependencies;

  const paginateUserMessages: paginateUserMessagesUseCase = async (
    conversationId,
    query,
  ) => {
    try {
      const messages = await conversationRepo.paginateMessages(
        conversationId,
        query,
      );
      return { [conversationId]: messages };
    } catch (error) {
      throw error;
    }
  };

  return paginateUserMessages;
};
